const SecuredComponent = props => {
  const { permission, permissions, children, store } = props;
  const state = store.getState();
  const { isAdmin } = state.auth;
  const userPermisions = state.auth.permissions;
  const neededPermissions = [];
  permission && neededPermissions.push(permission);
  permissions && neededPermissions.push(...permissions);

  return neededPermissions.every(x => isAdmin || userPermisions.includes(x)) ? children : null;
};

export default SecuredComponent;
